module.exports = __webpack_public_path__ + "img/9788932910987.7fdcf355.jpg";